/**
 * @file
 * @fileOverview  This file contains the light components for the Aframe scene.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

AFRAME.registerShader("normal-map-shader", {
    schema: {
      normalMap: { type: "map" },
    },
  
    init: function (data) {
      this.material = new THREE.MeshStandardMaterial({
        normalMap: new THREE.TextureLoader().load(data.normalMap),
        roughness: 0.5,
        metalness: 0.5,
      });
    },
  });
  
  AFRAME.registerComponent("apply-normal-map", {
    schema: {
      normalMap: { type: "map", default: "" },
    },
  
    init: function () {
      const el = this.el;
      el.setAttribute(
        "material",
        "shader: normal-map-shader; normalMap: " + this.data.normalMap,
      );
    },
  });

  export const lightComponents = {
    NormalMapShader: AFRAME.components['normal-map-shader'],
    ApplyNormalMap: AFRAME.components['apply-normal-map']
  };